/* Studio's reveal rhythm, shared by editorial pages and all footer variants. */
(() => {
  const targets = [
    '.atelier-hero__copy > *', '.atelier-split > *',
    '.atelier-production__intro', '.atelier-production__photo',
    '.atelier-team > p', '.atelier-team > h2', '.atelier-team__grid > article',
    '.chapter-one__intro > *', '.chapter-one__album-heading h2',
    '.chapter-one__grid > img', '.chapter-one__invitation > *',
    '.chapter-cover__copy > *', '.chapter-album__heading', '.chapter-album__grid > a',
    '.chapter-invitation > *', '.chapter-navigation > a',
    '.planners-hero__copy > *', '.planners-story > *', '.planners-trade__inner > h2',
    '.planners-trade__inner > p', '.planners-trade__grid > article',
    '.avant-planners .avant-press-band > *',
    '.planners-rooms > h2', '.planners-room > *', '.planners-process > h2', '.planners-process > p',
    '.planners-process__grid > *', '.planners-work > h2', '.planners-work__grid > *',
    '.planners-testimonials > *', '.planners-inquiry > *',
    '.standing-hero__copy > *', '.standing-masthead__copy > *',
    '.standing-masthead__gallery > img', '.standing-masthead__pair > img',
    '.standing-masthead__intro > *', '.standing-bespoke > div:first-child',
    '.standing-bespoke__gallery > img', '.standing-included > div',
    '.standing-process > p', '.standing-process > h2', '.standing-process article',
    '.standing-inquiry > *', '.standing-faq > *',
    '.planners-social > *', '.editorial-social > *',
    '.f-top > *', '.f-bottom'
  ].join(',');
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const pending = new Set();
  const show = (element) => {
    element.classList.add('is-avant-revealed');
    if (element.hasAttribute('data-reveal')) element.classList.add('in');
    pending.delete(element);
    if (observer) observer.unobserve(element);
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => { if (entry.isIntersecting) show(entry.target); });
  }, { threshold: 0.16, rootMargin: '0px 0px -6% 0px' }) : null;

  function init(root) {
    root.querySelectorAll(targets).forEach((element) => {
      // Existing Studio/Event reveals retain their own observer and stagger.
      const footer = element.matches('.f-top > *, .f-bottom');
      if ((!footer && element.closest('[data-reveal], [data-section-reveal]')) || element.hasAttribute('data-avant-reveal')) return;
      element.setAttribute('data-avant-reveal', '');
      if (motion.matches || !observer) { show(element); return; }
      pending.add(element);
      observer.observe(element);
    });
  }
  function boot() { init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    pending.forEach((element) => { if (event.target.contains(element)) show(element); });
  });
  document.addEventListener('focusin', (event) => {
    const element = event.target.closest('[data-avant-reveal]');
    if (element) show(element);
  });
  motion.addEventListener('change', () => { if (motion.matches) pending.forEach(show); });
})();
